<template>
	<div style="overflow: hidden;" class="p-mb-6">
		<div class="exportStyle">
			<h1>Study Outcomes</h1>
			<div v-if="columnDefs.length > 0">
				<fileOptions
					:gridApi="gridApi"
					:importFile="false"
					:fileType="fileType"
				/>
			</div>
		</div>
		<div
			v-if="columnDefs.length > 0"
			style="float: right; display: flex; align-items: center;"
		>
			<span style="margin-right: 10px;">Write Results</span>
			<label class="toggle-switch">
				<input
					type="checkbox"
					v-model="$tera.project.writeStudyOutcomesOnResultsSection"
				/>
				<span class="slider"></span>
			</label>
		</div>
		<div style="padding-top: 25px;" v-if="columnDefs.length > 0">
			<CustomDataTable
				:columnDefs="columnDefs"
				:rowData="rowData"
				:singleRow="singleRow"
				caller="StudyOutcomes"
				@api="getApi"
				@updateTable="updateTable"
				:tableStyle="getTableStyle"
			/>
		</div>
		<div
			v-if="columnDefs.length == 0"
			style="justify-self: center;display: flex; align-items: center;"
		>
			<span style="font-weight: 700;color: blue;font-style: italic;"
				>No Preview Found</span
			>
		</div>
	</div>
</template>

<script>
import CustomDataTable from "@/components/tableComponents/CustomDataTable.vue";
import VTooltip from "v-tooltip";
import fileOptions from "../../components/tableComponents/fileOptions.vue";

export default {
	name: "ViewMethodDataExtractionStudyOutcome",
	directives: {
		tooltip: VTooltip.directive
	},
	components: {
		CustomDataTable,
		fileOptions
	},
	data() {
		return {
			gridApi: null,
			gridOptions: {
				rowHeight: 50,
				defaultColDef: {
					width: 280 //default width of each column
				},
				flex: this.$tera.project.detableSudyOutcome.headers.length
			},
			rowData: this.$tera.project.detableSudyOutcome.rows,
			columnDefs: this.$tera.project.detableSudyOutcome.headers,
			fileType: "Excel"
			// outputComponent: OutputStudyOutcome
		};
	},
	beforeMount() {
		this.concatTables();
		this.rowData = this.$tera.project.detableSudyOutcome.rows;
		this.columnDefs = this.$tera.project.detableSudyOutcome.headers;
		this.singleRow = this.transformedHeaders();
		this.columnDefs.forEach(col => {
			this.$set(col, "cellRenderer", "tableEditor");
			col.cellRendererParams = { caller: "StudyOutcomes" };
		});
	},
	computed: {
		table() {
			let concatedArray = [];
			//[Extraction] methods + participants + interventions + comparators
			concatedArray = concatedArray.concat(
				this.$tera.project.methods.filter(
					x => x.label == "Study authors" || x.label == "Year"
				)
			);
			//[Extraction] extractionOutcomes (if included)
			let filteredOutcome = this.$tera.project.extractionOutcomes.filter(
				item => item.main
			);
			if (filteredOutcome && filteredOutcome.length > 0) {
				filteredOutcome.forEach(item => {
					// if (item.inclusion == true) {
					concatedArray.push({ label: item.main });
					// }
				});
			}
			//Add Headers in detableSudyOutcome - Only Outcomes and Study Authors and Year from methods
			return this.addHeaders(
				this.$tera.project.detableSudyOutcome,
				concatedArray
			);
		},
		getTableStyle() {
			return "height: auto;";
		}
	},
	methods: {
		tableHeight() {
			const rowCount = this.$tera.project.detableSudyOutcome.rows.length;
			const rowHeight = 50;
			const headerHeight = 60;
			const minHeight = headerHeight + rowHeight;
			const maxHeight = 800;

			//Total height of the table
			const calculatedHeight = headerHeight + rowCount * rowHeight;

			// Ensure the height is within the min and max bounds
			const finalHeight = Math.min(
				Math.max(calculatedHeight, minHeight),
				maxHeight
			);

			// console.log("Final Table Height:", finalHeight);
			return `${finalHeight}px`;
		},
		transformedHeaders() {
			const headersArray = this.$tera.project.detableSudyOutcome.headers;
			return headersArray.reduce((acc, item) => {
				if (item.field) {
					acc[item.field] = "";
				}
				return acc;
			}, {});
		},
		concatTables() {
			// Concatenate methods, participants, interventions, and comparators
			let concatenatedArray = [];
			concatenatedArray = concatenatedArray.concat(
				this.$tera.project.methods.filter(
					x => x.label == "Study authors" || x.label == "Year"
				)
			);
			//[Extraction] extractionOutcomes (if included)
			let filteredOutcome = this.$tera.project.extractionOutcomes.filter(
				item => item.main
			);
			if (filteredOutcome && filteredOutcome.length > 0) {
				filteredOutcome.forEach(item => {
					// if (item.inclusion == true) {
					concatenatedArray.push({
						label: item.main,
						cellRenderer: "tableEditor",
						field: item.main
							.toLowerCase()
							.replace(/[-\s]+(.)?/g, (_, char) =>
								char ? char.toUpperCase() : ""
							)
							.replace(/^(.)/, (_, char) => char.toLowerCase()),
						headerName: item.main
					});
					// }
				});
			}
			// Add headers and rows to detableSudyOutcome
			this.addHeaders(this.$tera.project.detableSudyOutcome, concatenatedArray);
		},
		addHeaders(table, concatArray) {
			const xLabels = new Set(concatArray.map(item => item.field));
			// Use this.$set to ensure reactivity when updating headers
			this.$set(table, "headers", [...concatArray]);

			if (table.rows.length === 0) {
				const newRow = {};
				for (const field of xLabels) {
					newRow[field] = "";
				}
				this.$set(table, "rows", [...table.rows, newRow]);
			} else {
				const updatedRows = table.rows.map(row => {
					const newRow = {};
					for (const field of xLabels) {
						newRow[field] = row[field] || "";
					}
					return newRow;
				});

				this.$set(table, "rows", updatedRows);
			}
		},
		getApi(api) {
			this.gridApi = api;
			//Add EventListener : for normal cell in ag-grid
			this.gridApi.forEachNode(node => {
				node.addEventListener("cellChanged", this.cellChangeHandler);
			});
		},
		updateTable(event) {
			//Row $tera.project change
			this.singleRow = this.transformedHeaders();
			//Row $tera.project change
			if (event.e == "Row") {
				event.dir == 0
					? this.$tera.project.detableSudyOutcome.rows.splice(
							event.rn.childIndex,
							1
					  )
					: this.$tera.project.detableSudyOutcome.rows.splice(
							event.rn.childIndex,
							0,
							// event.rn.data
							this.transformedHeaders()
					  );
				//Add Listener for monioring the new node contents change

				//event.rn.addEventListener("cellChanged", this.cellChangeHandler);
				this.gridApi.forEachNode(n => {
					if (n.childIndex == event.rn.childIndex) {
						n.addEventListener("cellChanged", this.cellChangeHandler);
					}
				});
			}
			//Column $tera.project change
			if (event.changeEvent == "Column") {
				// console.log("col:", event);
				event.Dir == 0
					? this.$tera.project.detableSudyOutcome.headers.splice(
							event.ColInfo.selectedIndex,
							1
					  )
					: event.Dir > 0
					? this.$tera.project.detableSudyOutcome.headers.splice(
							event.ColInfo.selectedIndex,
							0,
							event.ColInfo.col
					  )
					: this.$tera.project.detableSudyOutcome.headers.splice(
							event.ColInfo.selectedIndex + 1,
							0,
							event.ColInfo.col
					  );
			}
		},
		cellChangeHandler(e) {
			this.$tera.project.detableSudyOutcome.rows[e.node.childIndex] =
				e.node.data;
		},
		showJson() {
			console.log(JSON.stringify(this.$tera.project.detableSudyOutcome));
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ag-root-wrapper.ag-layout-normal {
	/* height: v-bind(tableHeight); */
	/* width: v-bind(tablewidth); */
	-webkit-overflow-scrolling: touch;
}

.exportStyle {
	display: flex;
	align-items: center;
}
.toggle-switch {
	cursor: pointer;
	position: relative;
	display: inline-block;
	width: 50px;
	height: 25px;
}
.toggle-switch input {
	display: none;
}
.slider {
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: #ccc;
	transition: 0.4s;
	border-radius: 25px;
}
.slider:before {
	position: absolute;
	content: "";
	height: 19px;
	width: 19px;
	left: 3px;
	bottom: 3px;
	background-color: white;
	transition: 0.4s;
	border-radius: 50%;
}
input:checked + .slider {
	background-color: #485d8d;
}
input:checked + .slider:before {
	transform: translateX(25px);
}
</style>
